module.exports = __webpack_public_path__ + "img/attach-file-icon.0dc86735.svg";